const React = require('react');
const {pdf} = require("@react-pdf/renderer");
const map = require('mn-utils/map');
const defer = require('mn-utils/defer');
const OpenInNewIcon = require('@material-ui/icons/OpenInNew').default;
const {base: downloadBase} = require("mn-utils/browser/download");
const getTime = require("mn-utils/time");
const withReDelay = require("mn-utils/withReDelay");
const upperFirst = require("mn-utils/upperFirst");

const DownloadIcon = require('../../../icons/Download');
const {
  LINK_ADMIN_ACCOUNT_KYC_ITEM,
} = require('../../../../constants/links');
const {
  Link,
} = require('../../../../router');
const {
  apiAdminKYCVerificationStateUpdate,
  apiAdminAccountsKYCList, apiAdminAccountsKYCGet,
} = require('../../../../api/admin/accountsKYC');
const {
  approveOpen, openPopupInfo,
} = require('../../../../emitters/popup');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const Ripple = require('../../../dumb/Ripple');
const ButtonUp = require('../../../dumb/Button/Up');
const Menu = require('../../../dumb/Menu');
const Tooltip = require('../../../dumb/Tooltip/A');
const MenuVertIcon = require('../../../icons/MenuVert');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');
const {AdminTimeCell} = require("../../../dumb/TableTimeCell");
const {IntervalFilterAdmin, getFilterParams} = require("../../../dumb/IntervalFilterCustom");
const {paramStore} = require("../../../../stores");
// const {makePDF} = require("../../../../dynamic-modules/pdfMakeKYC");
const makePDF = require("../../../../dynamic-modules/pdfMakeKYC");
const formatNumCurrency = require("../../../../utils/formatNumCurrency");
const downloadKycPdf = require("../../../../utils/downloadKycPdf");

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

const filter$ = paramStore('filter', {});

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
  },
  rowHeight: 70,
  request: apiAdminAccountsKYCList,
  getParams: getFilterParams(),
  wrapper(render, setState, self) {
    function updateItem(accountId, verificationState, verificationMessage) {
      defer(setState, [{
        loading: true,
      }]);
      return apiAdminKYCVerificationStateUpdate({
        account_id: accountId,
        verification_state: verificationState,
        verification_message: verificationMessage,
      }).finally((error) => {
        const {
          state,
        } = self;
        const data = state.data || {};
        setState({
          loading: false,
          data: error ? data : {
            ...data,
            list: map(state.list, (v) => {
              return v.id === accountId ? {
                ...v,
                verification_state: verificationState,
                verification_message: verificationMessage,
              } : v;
            }, []),
          },
        });
      });
    }

    function handleChangeFilter(filter) {
      const update = withReDelay(self.update, 1000);
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    function Item({
      data,
    }) {
      const id = data.id || '';
      const login = data.login || '';
      const lifeflow = data.lifeflow || '';
      const verificationState = data.verification_state || '';
      const verificationMessage = data.verification_message || '';
      const time = data.updated_at || '';

      function getMenuItem(name, status) {
        return {name, onClick() {
          updateItem(id, status, '').then(() => {
            openPopupInfo([`${login} application has been ${status}`]);
          });
          // approveOpen({
          //   title: name,
          //   callback(message) {
          //     updateItem(id, status, message);
          //   },
          // });
        }};
      }

      return (
        <RowA>
          <ColA className="wmin180 fx1">
            <DisplayIdAdmin>{id}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin200 fx1">
            <DisplayDataAdmin>{login}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin120 fx1">
            <DisplayDataAdmin>{data.role}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin200 fx1">
            <DisplayDataAdmin>{lifeflow}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin150 fx1">
            <DisplayDataAdmin>{verificationState}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin150 fx1">
            <DisplayDataAdmin>{
              verificationMessage.length > 1024
                ? verificationMessage.substr(0, 1024) + '...'
                : verificationMessage
            }</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin125">
            <DisplayDateTimeAdmin
              date={time}
            />
          </ColA>
          <ColA className="w130">{data.blocked ? 'Yes' : 'No'}</ColA>
          <ColA className="w170">
            {
              id ? (
                <div className="rt layoutRow fhaB fvaC">
                  <Ripple
                    className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                      bgF.03:h"
                    centerRipple
                    component={Link}
                    href={LINK_ADMIN_ACCOUNT_KYC_ITEM + id}
                  >
                    <OpenInNewIcon/>
                  </Ripple>
                  <Ripple
                    className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                      bgF.03:h"
                    centerRipple
                    onClick={() => {
                      apiAdminAccountsKYCGet({
                        skipError: 1,
                        account_id: id,
                      }).then(downloadKycPdf);
                    }}
                  >
                    <DownloadIcon width="24" height="24" />
                  </Ripple>
                  <Menu
                    transformOriginTop="right top"
                    transformOriginBottom="right bottom"
                    items={[
                      getMenuItem('Approve', 'approved'),
                      getMenuItem('Reject', 'rejected'),
                      getMenuItem('Submitted', 'submitted'),
                      getMenuItem('Pending', 'pending'),
                    ]}
                  >
                    <Ripple
                      className="layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                        bgF.03:h"
                      centerRipple
                    >
                      <MenuVertIcon className="w5 cF"/>
                    </Ripple>
                  </Menu>
                </div>
              ) : null
            }
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      const filter = state.filter;

      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Accounts pending KYC verification</CaptionA>
          </HeaderA>
          <IntervalFilterAdmin
            className="mt16"
            data={filter}
            search={{
              className: 'w260',
              placeholder: 'Search by Email'
            }}
            onChange={handleChangeFilter}
            hideTimeInterval
          />
          <div className="abs st140 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin1380 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin180 fx1">ID</ColB>
                    <ColB className="wmin200 fx1">Email</ColB>
                    <ColB className="wmin120 fx1">Role</ColB>
                    <ColB className="wmin200 fx1">Lifeflow</ColB>
                    <ColB className="wmin150 fx1">Verification<br/>state</ColB>
                    <ColB className="wmin150 fx1">Verification<br/>message</ColB>
                    <ColB className="wmin125">Updated at</ColB>
                    <ColB className="w130">Blocked</ColB>
                    <ColB className="wmin170"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
